
import {
    Prop,
    Component,
    Vue
} from "vue-property-decorator";
import {
    Pie,
    mixins
} from "vue-chartjs";

@Component({
    extends: Pie
})
export default class PieChartBase extends Vue {
    @Prop(Object) chartData!: Object;
    @Prop(Object) options!: Object;

    mounted() {
        (this as any).renderChart(this.chartData, this.options, {
            borderWidth: "10px",
            hoverBackgroundColor: "red",
            hoverBorderWidth: "10px",
            
        }
        
        );
    }
    /*
     mounted() {
        (this as any).renderChart(this.chartData,
            // {
            //         borderWidth: "10px",
            //         hoverBackgroundColor: "red",
            //         hoverBorderWidth: "10px",

            //     },
            this.options = {
                tooltips: {
                    enabled: false
                },
                // plugins: {
                //     datalabels: {
                //         formatter: (value: any, ctx: any) => {
                //             let sum = 0;
                //             let dataArr = ctx.chart.data.datasets[0].data;
                //             dataArr.map((data: any) => {
                //                 sum += data;
                //             });
                //             let percentage = (value * 100 / sum).toFixed(2) + "%";
                //             return percentage;

                //         },
                //         color: '#000',
                //     }
                // }
            }

        );
    }
    */
}
